import DevourClient from 'devour-client';

export const TYPE = 'user/story/cluster';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			radius: '',
			objectCount: '',
			longitude: '',
			latitude: '',
		},
		{
			type: TYPE,
		}
	);

	return client;
}
